export const graphql = {
  LOCAL: {
    url: process.env.REACT_APP_GRAPHQL_URL_LOCAL,
  },
  DEV: {
    url: 'https://dashboard-gql-dev.wahed.tech',
  },
  STAGING: {
    url: 'https://dashboard-gql-staging.wahed.tech',
  },
  PROD: {
    url: 'https://dashboard-gql-prod.wahed.tech',
  },
};

const relayCache = 250;
export const getRelayCacheSize = () => {
  return relayCache;
};
